/** Lengths in rendered model coordinates; no assumed metres conversion. */
export function measurementValues(a, b) {
  if (![a, b].every(v => Array.isArray(v) && v.length === 3 && v.every(Number.isFinite))) throw new Error('量測座標無效');
  const [dx, dy, dz] = b.map((n, i) => n - a[i]);
  return { distance: Math.hypot(dx, dy, dz), horizontal: Math.hypot(dx, dy), height: Math.abs(dz), deltaZ: dz };
}
export function boxRange(value) {
  if (!value || !['min', 'max'].every(k => Array.isArray(value[k]) && value[k].length === 3 && value[k].every(n => Number.isFinite(n) && n >= 0 && n <= 1))
      || value.min.some((n, i) => n > value.max[i])) throw new Error('剖切盒範圍需為 0–100%，起點不可大於終點');
  return { min: [...value.min], max: [...value.max] };
}

export const metresPerUnit={mm:.001,cm:.01,m:1,ft:.3048};
export function angleDegrees(a,b,c){
 const u=a.map((n,i)=>n-b[i]),v=c.map((n,i)=>n-b[i]);
 const length=Math.hypot(...u)*Math.hypot(...v);if(length<1e-20)throw new Error('角度量測的點不可重合');
 return Math.acos(Math.max(-1,Math.min(1,u.reduce((s,n,i)=>s+n*v[i],0)/length)))*180/Math.PI;
}
export function calibratedScale(rawDistance,distance,unit){
 if(!(rawDistance>0)||!(distance>0)||!metresPerUnit[unit])throw new Error('校正距離需大於零');
 return distance*metresPerUnit[unit]/rawDistance;
}
